import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { MixpanelConsumer } from 'react-mixpanel';

import PrivateRoute from 'components/common/shared/PrivateRoute';
import StartPage from 'components/StartPage/StartPage';
import Login from 'pages/Auth/Login/LoginPage';
import PasswordReset from 'pages/Auth/Login/PasswordReset';
import UserProfile from 'pages/UserProfile/UserProfile';

import Storybook from 'components/common/Elements/Storybook';
import PageNotFound from 'components/navigation/PageNotFound/PageNotFound';

import Release from 'pages/Release/Release';
import GroupsRelease from 'pages/GroupsRelease/GroupsRelease';
import DelGroups from 'pages/DelGroups/DelGroups';
import CreateFirstRelease from 'pages/CreateFirstRelease/CreateFirstRelease';
import Shared from './pages/Shared/Shared';

const Routs = ({ onOfNotif }) => {
  return (
    <div>
      <Switch>
        <Route exact path="/" component={StartPage} />
        <Route exact path="/login" component={Login} />
        <Route
          exact
          path="/password-reset/:idreset"
          render={props => (
            <MixpanelConsumer>
              {mixpanel => (
                <PasswordReset
                  mixpanel={mixpanel}
                  onOfNotif={onOfNotif}
                  {...props}
                />
              )}
            </MixpanelConsumer>
          )}
        />

        <PrivateRoute
          exact
          path="/newrelease/:groupId"
          component={CreateFirstRelease}
          onOfNotif={onOfNotif}
        />
        <Route exact path="/storybook" component={Storybook} />
        <PrivateRoute exact path="/groups/deleted" component={DelGroups} />
        <PrivateRoute exact path="/groups" component={GroupsRelease} onOfNotif={onOfNotif}/>
        <PrivateRoute
          exact
          path="/groups/:groupId"
          component={Release}
          onOfNotif={onOfNotif}
        />
        <PrivateRoute
          exact
          path="/groups/:groupId/:releaseId"
          component={Release}
          onOfNotif={onOfNotif}
        />
        <PrivateRoute
          exact
          path="/userprofile"
          component={UserProfile}
          onOfNotif={onOfNotif}
        />

        <Route exact path="/share/:token/:groupId" component={Shared} />
        <Route
          exact
          path="/share/:token/:groupId/:releaseId"
          component={Shared}
        />
        <Route component={PageNotFound} />
      </Switch>
    </div>
  );
};

export default Routs;
